/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1ClusterEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_CLUSTER_EVENT_ENTITY_NAME = 'o5.aws.deployer.v1.ClusterEvent';
export const o5AwsDeployerV1ClusterEventEntity = new schema.Entity<O5AwsDeployerV1ClusterEvent>(O5_AWS_DEPLOYER_V1_CLUSTER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: O5AwsDeployerV1ClusterEvent) => `${entity.metadata?.eventId}` });

